import React from 'react';
import Form from './Form';

import { IComponentForm } from '../../component.d';

import './form.scss';

const AllForForm = function(props: IComponentForm) {
  return (
    <div className="all-for-form">
      <Form {...props} />
    </div>
  );
};

export default AllForForm;
